import { IPlano } from "../interfaces/IPlanoCliente";
import api from "./Api";

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

class PlanoNovaService {
    async buscar(): Promise<IPlano[]> {
        const { data: result } = await api.get<IPlano[]>('Plano', { baseURL: BASE_URL });
        return result;
    }

    async listarTodos(): Promise<IPlano[]> {
        const { data: result } = await api.get<IPlano[]>('Plano/todos', { baseURL: BASE_URL });
        return result;
    }
}

export default new PlanoNovaService();
